import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import "../../Styles/profileDetails.scss";
import HeaderComp from "../HeaderComponent/HeaderComp";
import { profileSettings } from "../../redux/reducers/profileSettingReducer";
import { useDispatch, useSelector } from "react-redux";
import PersonalDetailsForm from "./Component/PersonalDetailsForm";
import SecurityDetailsForm from "./Component/SecurityDetailsForm";
import { getCountries } from "../../redux/reducers/countriesReducer";
import LoadingSpinner from "../LoadingSpinner";

export default function ProfileDetails() {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.profileSettings?.isGetDistributorDetailLoading);

  // Fetch distributor details
  useEffect(() => {
    dispatch(profileSettings({dispatch})); 
    dispatch(getCountries({dispatch}));
  }, [dispatch]);

  
  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <HeaderComp />

      <div className="profileHead">PROFILE SETTINGS</div>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        className="profileDetails-box-style"
      >
        <PersonalDetailsForm/>
        <SecurityDetailsForm/>        
      </Box>
    </div>
  );
}
